import React from "react";
import { CalendarClock } from "lucide-react";

const TeamSection = ({ 
  members, 
  activeTab, 
  onMemberClick,
  onBookMeeting,
  isEvent
}) => {
  if (!((activeTab === "all" || activeTab === "booth_member") && members?.length > 0)) {
    return null;
  }

  return (
    <section className="space-y-8">
      <div className="flex items-center gap-3">
        <div className="w-1.5 h-8 bg-indigo-600 rounded-full" />
        <h2 className="text-xl font-semibold text-slate-900">
          Booth Member
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {members.map((member) => {
          const fullName = `${member.first_name} ${member.last_name}`;
          const initials = fullName
            .split(" ")
            .map((n) => n?.[0])
            .filter(Boolean)
            .join("")
            .toUpperCase()
            .slice(0, 2);
          const gradients = [
            "from-emerald-500 to-teal-600",
            "from-blue-500 to-indigo-600",
            "from-purple-500 to-violet-600",
            "from-orange-500 to-red-600",
            "from-pink-500 to-rose-600",
          ];
          const gIndex = (member.first_name?.charCodeAt(0) || 0) % gradients.length;

          return (
            <div
              key={member.id}
              onClick={() => onMemberClick(member)}
              className="bg-white p-4 rounded-xl border border-slate-200 flex items-center gap-4 shadow-sm hover:shadow-md transition-all duration-300 relative overflow-hidden group cursor-pointer"
            >
              {/* Avatar */}
              <div
                className={`w-14 h-14 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-inner flex-shrink-0 bg-gradient-to-br ${gradients[gIndex]}`}
              >
                {member.profile_image ? (
                  <img
                    src={member.profile_image}
                    alt={fullName}
                    className="w-full h-full rounded-full object-cover"
                  />
                ) : (
                  <span>{initials}</span>
                )}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <h4 className="font-bold text-slate-800 text-base truncate">
                  {fullName}
                </h4>
                {member.has_meet_availability ? (
                  <button
                    disabled={!isEvent}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isEvent) {
                        onBookMeeting(member);
                      }
                    }}
                    className={`mt-3 flex items-center gap-2 transition-colors group/btn ${
                      isEvent 
                        ? "text-[#0070C0] hover:text-[#005a9e]" 
                        : "text-gray-400 cursor-not-allowed opacity-60"
                    }`}
                  >
                    <CalendarClock size={16} className={isEvent ? "group-hover/btn:scale-110 transition-transform" : ""} />
                    <span className={`text-sm font-bold border-b border-transparent pb-0.5 ${isEvent ? "group-hover/btn:border-[#0070C0]" : ""}`}>
                      Book a meeting
                    </span>
                  </button>
                ) : null}
              </div>

              {/* Bottom Accent Line */}
              <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-purple-500 to-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TeamSection;
